import React from 'react';
import { Avatar } from '@here/hds-avatar';
// eslint-disable-next-line no-new
new Avatar();
const HDSAvatarButton = React.forwardRef((props, ref) => {
    const { children, ...rest } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const clone: any = React.isValidElement(children)
    //   ? React.cloneElement(children, {ref})
    //   : children;
    const elementProps = {
        ...rest,
        role: 'button',
        tabIndex: 0,
    };
    return (React.createElement("span", { className: "hds-avatar-wrapper", ...elementProps, ref: ref }, children));
});
export default HDSAvatarButton;
//# sourceMappingURL=HDSAvatarButton.js.map